import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class FilterTopbar extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string
  };

  render() {
    const barClass = classNames(['filter-bar', this.props.className]);

    return (
      <div className={barClass}>
        {this.props.children}
      </div>
    );
  }
}
